"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverrideValidator = exports.sendValidationRequest = void 0;
const tlru_cache_1 = require("./cache/tlru-cache");
const FIVE_MINUTES_IN_MS = 5 * 3600 * 1000;
const KEY_VALIDATION_URL = 'https://eppo.cloud/api/flag-overrides/v1/validate-key';
const sendValidationRequest = async (browserExtensionKey) => {
    const response = await fetch(KEY_VALIDATION_URL, {
        method: 'POST',
        body: JSON.stringify({
            key: browserExtensionKey,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (response.status !== 200) {
        throw new Error(`Unable to authorize key: ${response.statusText}`);
    }
};
exports.sendValidationRequest = sendValidationRequest;
class OverrideValidator {
    constructor() {
        this.validKeyCache = new tlru_cache_1.TLRUCache(100, FIVE_MINUTES_IN_MS);
    }
    parseOverridePayload(overridePayload) {
        const errorMsg = (msg) => `Unable to parse overridePayload: ${msg}`;
        try {
            const parsed = JSON.parse(overridePayload);
            this.validateParsedOverridePayload(parsed);
            return parsed;
        }
        catch (err) {
            const message = err?.message ?? 'unknown error';
            throw new Error(errorMsg(message));
        }
    }
    validateParsedOverridePayload(parsed) {
        if (typeof parsed !== 'object') {
            throw new Error(`Expected object, but received ${typeof parsed}`);
        }
        const keys = Object.keys(parsed);
        if (!keys.includes('browserExtensionKey')) {
            throw new Error(`Missing required field: 'browserExtensionKey'`);
        }
        if (!keys.includes('overrides')) {
            throw new Error(`Missing required field: 'overrides'`);
        }
        if (typeof parsed['browserExtensionKey'] !== 'string') {
            throw new Error(`Invalid type for 'browserExtensionKey'. Expected string, but received ${typeof parsed['browserExtensionKey']}`);
        }
        if (typeof parsed['overrides'] !== 'object') {
            throw new Error(`Invalid type for 'overrides'. Expected object, but received ${typeof parsed['overrides']}.`);
        }
    }
    async validateKey(browserExtensionKey) {
        if (this.validKeyCache.get(browserExtensionKey) === 'true') {
            return true;
        }
        await (0, exports.sendValidationRequest)(browserExtensionKey);
        this.validKeyCache.set(browserExtensionKey, 'true');
    }
}
exports.OverrideValidator = OverrideValidator;
//# sourceMappingURL=override-validator.js.map